import Vue from 'vue';
import Vuex from 'vuex';
import { rest } from "@/utilities/rest.js";

Vue.use(Vuex);

export default new Vuex.Store({

	modules: {
	},

	state: {

		user: null,
		payment: null,
		membershipConfig: null,
		familyMembers: [],
		locations: [],
		plans: {},
		familyConfig: null,
		accordionConfig: null,
		dialogWidth: "50%" 

	},

	getters: {

		user: state => {
			return state.user;
		},

		payment: state => {
			return state.payment;
		},
		plans: state => {
			return state.plans;
		},

		familyMembers: state => {
			return state.familyMembers;
		},

		familyConfig: state => {
			return state.familyConfig;
		},

		locations: state => {
			return state.locations;
		},

		modalWidth: state => {
			return state.dialogWidth;
		},

		accordionConfig: state => {
			return state.accordionConfig;
		},

		membershipConfig: state => {
			return state.membershipConfig;
		}

	},

	mutations: {
		setUser(state, payload) {
			state.user = payload;
		},

		setFamilyMembers(state, payload) {
			state.familyMembers = payload;
		},

		setPayment(state, payload) {
			state.payment = payload;
		},

		setConfiguration(state, payload) {
			state.locations = payload.shared.locations;
			state.plans = payload.shared.plans;
			state.familyConfig = payload.account.family;
			state.accordionConfig = payload.account.accordion;
			state.membershipConfig = payload.account.membership;
		},

		setDialogWidth(state, payload) {
			state.dialogWidth = payload;
		}
	},

	actions: {
		getConfiguration: (context, payload) => {
			return new Promise((resolve, reject) => {
				rest.get("Account/", "GetConfiguration", "json")
					.done(function (response) {
						context.commit("setConfiguration", JSON.parse(response));
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText).Message);
					});
			});
		},

		getUser: (context, payload) => {
			return new Promise((resolve, reject) => {
				rest.get("Account/", "GetUser", "json", { userId: payload })
					.done(function (response) {
						context.commit("setUser", response);
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText).Message);
					});
			});
		},

		getPayment: (context, payload) => {
			return new Promise((resolve, reject) => {
				rest.get("Account/", "GetPaymentInfo", "json", { userId: payload })
					.done(function (response) {
						context.commit("setPayment", response);
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText));
					});
			});
		},

		getFamilyMembers: (context, payload) => {
			return new Promise((resolve, reject) => {
				rest.get("Account/", "GetFamilyMembers", "json", { userId: payload })
					.done(function (response) {
						context.commit("setFamilyMembers", response);
						resolve();
					}).fail(function (xhr) {
						reject(JSON.parse(xhr.responseText));
					});
			});
		},
		
  }
})
